export class Animation2DEvent {
    constructor() {
    }
}
